import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ChartProgress from './ChartProgress.vue'
import ChartBar from './ChartBar.vue'
import { convertMinutesToTimeJp } from '../../../../lib/convert'

// Props
interface TimeGraphData {
  labels: string[]
  datasets: {
    [x: string]: any
    label: string
    data: number[]
  }[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardTimeSummary',
  props: {
    timeGraphData: { default: null },
    startDate: {},
    endDate: {},
    height: { default: 100 },
    width: { default: null }
  },
  setup(__props: any) {

const props = __props

// Chart Options
const chartOptions = {
  elements: {
    line: {
      tension: 0
    }
  },
  plugins: {
    legend: {
      display: true,
      position: 'top' as const,
      align: 'end' as const
    },
    tooltip: {
      callbacks: {
        label: function(context: any) {
          let label = context.dataset.label || '';
          if (label) {
            label += ': ';
          }
          const minutes = Math.round(context.parsed.y * 100) / 100;
          label += convertMinutesToTimeJp(minutes);
          return label;
        }
      }
    }
  },
  scales: {
    x: {
      // display: false
    },
    y: {
      display: true,
      beginAtZero: true
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ChartBar, {
      data: __props.timeGraphData,
      height: __props.height,
      width: __props.width,
      chartOptions: chartOptions
    }, null, 8 /* PROPS */, ["data", "height", "width"])
  ]))
}
}

})